export default "__VITE_ASSET__EIHezoA0__"